import GetStartedPage from 'components/GetStarted'

export default GetStartedPage
